import React, { memo } from 'react';
import { Box } from '@material-ui/core';
import { blueprintPreviewUrl } from '../utils/fileHelpers';

const BlueprintChatPreview = ({ data, isDarkMode }) => {
  if (!data?.blueprint_id) return null;
  const preview = blueprintPreviewUrl(data);
  const markers = data.markers || [];
  const w = data.width || 1;
  const h = data.height || 1;

  return (
    <Box sx={{ mt: 1.5, maxWidth: 360 }}>
      <Box
        sx={{
          position: 'relative',
          display: 'inline-block',
          maxWidth: '100%',
          borderRadius: '12px',
          overflow: 'hidden',
          border: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.08)'}`,
        }}
      >
        {preview && (
          <Box
            component="img"
            src={`${preview}?t=${data.blueprint_id}`}
            alt="Blueprint preview"
            sx={{ width: '100%', display: 'block' }}
          />
        )}
        {markers
          .filter((m) => m.status !== 'deleted')
          .map((m) => (
            <Box
              key={m.marker_id}
              sx={{
                position: 'absolute',
                left: `${(m.x / w) * 100}%`,
                top: `${(m.y / h) * 100}%`,
                transform: 'translate(-50%, -100%)',
                fontSize: 22,
                lineHeight: 1,
                pointerEvents: 'none',
                userSelect: 'none',
              }}
            >
              📍
            </Box>
          ))}
      </Box>
    </Box>
  );
};

export default memo(BlueprintChatPreview);
